const FONT = '"Public Sans", sans-serif';

export default function EmptyState({ icon: Icon, color, title, description, action, className = '' }) {
  const iconColor = color || 'rgba(255, 255, 255, 0.3)';

  return (
    <div
      className={`flex flex-col items-center justify-center gap-2 px-6 py-8 text-center ${className}`}
      role="status"
    >
      {Icon && (
        <span
          className="flex items-center justify-center w-11 h-11 rounded-2xl mb-1"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.035)' }}
        >
          <Icon size={22} color={iconColor} style={{ opacity: color ? 0.72 : 1 }} />
        </span>
      )}
      {title && (
        <p
          className="m-0"
          style={{
            fontSize: '15px',
            lineHeight: '20px',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            color: 'rgba(255, 255, 255, 0.9)',
            fontFamily: FONT,
          }}
        >
          {title}
        </p>
      )}
      {description && (
        <p
          className="m-0"
          style={{
            fontSize: '13px',
            lineHeight: '19px',
            fontWeight: 500,
            color: 'rgba(255, 255, 255, 0.4)',
            maxWidth: '220px',
            fontFamily: FONT,
          }}
        >
          {description}
        </p>
      )}
      {action}
    </div>
  );
}
